import { useMemo } from "react";

import { TextMessages } from "V2.0/HomePages/Threads/components/conversation_messages";

import EvalRunResultSelectedItemEmpty from "../EvalRunResultSelectedItemEmpty";
import { EvalEvent } from "../../types";

export default EvalRunResultMessages;

// Coach guidance events are logged with the 1-based turn they were generated in
// (GptService.internalInteractionCount), and conversation[i] is turn i + 1.
function groupCoachGuidanceByMessageIndex(events) {
  return (events ?? []).reduce((acc, event) => {
    if (event.event !== EvalEvent.COACH_GUIDANCE) return acc;
    const guidance = event.details?.guidance;
    if (!guidance) return acc;
    const index = Number(event.turn) - 1;
    if (!Number.isInteger(index) || index < 0) return acc;
    acc[index] = [...(acc[index] ?? []), event];
    return acc;
  }, {});
}

function CoachGuidanceCallout({ event }) {
  const { guidance, model, kbSearches } = event.details ?? {};

  return (
    <div className="mx-6 -mt-2 mb-4 flex justify-end">
      <div className="max-w-[75%] rounded-md border border-amber-200 bg-amber-50 px-3 py-2">
        <p className="text-xs font-semibold text-amber-800 mb-1">
          Coach guidance
          {model ? (
            <span className="font-normal text-amber-700"> · {model}</span>
          ) : null}
          {Number.isFinite(kbSearches) && kbSearches > 0 ? (
            <span className="font-normal text-amber-700">
              {" "}
              · {kbSearches} KB search{kbSearches === 1 ? "" : "es"}
            </span>
          ) : null}
        </p>
        <p className="text-sm text-gray-800 whitespace-pre-wrap">{guidance}</p>
      </div>
    </div>
  );
}

function EvalRunResultMessages(props) {
  const { evalRunResultMessages, evalRunResultEvents } = props;

  const guidanceByIndex = useMemo(
    () => groupCoachGuidanceByMessageIndex(evalRunResultEvents),
    [evalRunResultEvents],
  );

  if (evalRunResultMessages.length === 0)
    return <EvalRunResultSelectedItemEmpty itemName="Messages" />;

  // OLD: return <TextMessages messages={evalRunResultMessages} />;
  // NEW: render each exchange on its own so the coach guidance generated during that turn can
  // sit directly under the assistant's reply, where a reviewer compares the two.
  if (Object.keys(guidanceByIndex).length === 0) {
    return <TextMessages messages={evalRunResultMessages} />;
  }

  return (
    <div>
      {evalRunResultMessages.map((message, index) => (
        <div key={index}>
          <TextMessages messages={[message]} />
          {(guidanceByIndex[index] ?? []).map((event, eventIndex) => (
            <CoachGuidanceCallout key={eventIndex} event={event} />
          ))}
        </div>
      ))}
    </div>
  );
}
